/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useContext, useState, useEffect, useMemo} from 'react'
import {useQuery} from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  initialQueryState,
  PaginationState,
  QUERIES,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import {getContents} from './_requests'
import {Content} from './_models'
import {useQueryRequest} from './QueryRequestProvider'
import {runAuthenticatedQuery} from '../../../../auth/core/session'

const CONTENT_LIST_REFETCH_INTERVAL = 10_000

const QueryResponseContext = createResponseContext<Content>(initialQueryResponse)
const QueryResponseProvider: FC<WithChildren> = ({children}) => {
  const {state} = useQueryRequest()
  const [query, setQuery] = useState<string>(stringifyRequestQuery(state))
  const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state])

  useEffect(() => {
    if (query !== updatedQuery) {
      setQuery(updatedQuery)
      console.log("updatedQuery ", updatedQuery)
      console.log("query ", query)
    }
  }, [updatedQuery])

  const {
    isFetching,
    isLoading,
    isPreviousData,
    refetch,
    data: response,
  } = useQuery(
    `${QUERIES.CONTENTS_LIST}-${query}`,
    () => runAuthenticatedQuery(() => getContents(query)),
    {
      cacheTime: 0,
      keepPreviousData: true,
      refetchInterval: CONTENT_LIST_REFETCH_INTERVAL,
      refetchIntervalInBackground: true,
      refetchOnReconnect: true,
      refetchOnWindowFocus: true,
      staleTime: 0,
    }
  )

  return (
    <QueryResponseContext.Provider
      value={{isLoading: isLoading || (isFetching && isPreviousData), refetch, response, query}}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

const useQueryResponse = () => useContext(QueryResponseContext)

const useQueryResponseData = () => {
  const {response} = useQueryResponse()
  if (!response) {
    return []
  }

  return response?.data || []
}

const useQueryResponsePagination = () => {
  const defaultPaginationState: PaginationState = {
    links: [],
    ...initialQueryState,
  }

  const {response} = useQueryResponse()
  if (!response || !response.payload || !response.payload.pagination) {
    return defaultPaginationState
  }

  return response.payload.pagination
}

const useQueryResponseLoading = (): boolean => {
  const {isLoading} = useQueryResponse()
  return isLoading
}

export {
  QueryResponseProvider,
  useQueryResponse,
  useQueryResponseData,
  useQueryResponsePagination,
  useQueryResponseLoading,
}
